<style scoped>
table {
    border-collapse: collapse;
}

table, th, td {
    border: 1px solid black;
    padding: 8px;

}

</style>

<template>
  <div>
    <h2>Dossier</h2>

    <table v-if="values">
      <tr><th width="30%">Question</th><th>Réponse</th></tr>
      <tr v-for="(v,k,i) in values">
      <td>
        <span v-html="getQuestionContent(k)"></span>
      </td>
      <td v-html="getResponse(v, k, i)"></td></tr>
    </table>
  </div>
</template>



<script>
import ServiceAccess from '../service/ServiceAccess'
import moment from 'moment'


export default {

  data: function () {
    return {
      purchases: [],
      values: null,
      questions: null

    }
  },

  created: function () {
    global.navigationBarBus.$emit('display-save', false)

    let promises = [
      ServiceAccess.instance.purchases(this.$route.params.sessionId),
      ServiceAccess.instance.loadValues(this.$route.params.sessionId),
      ServiceAccess.instance.loadQuestions()
    ]
    Promise.all(promises).then(responses => {
      let [purchases, values, questions] = responses
      this.values = values
      this.purchases = purchases
      this.questions = questions
    })
  },


  methods: {

    getQuestionContent: function (k) {

      if (this.questions[k]) {
        return this.questions[k].q.fr
      } else {
        if (k === '_files') {
          return 'Fichiers'
        }
      }
      return k
    },

    getResponse: function (v, k, i) {
      // return JSON.stringify(v)
      if (k === '_files') {
        let ffiles = this.values[k]
        return Object.keys(ffiles).map(kf => {
          let files = ffiles[kf]
          let kqs = Object.keys(this.questions).filter(kq => kf.startsWith(kq))
          // keep longest
          let kq = null
          if (kqs && kqs.length > 0) {
            kq = kqs.reduce((prev, curr, index, array) => { 
              return curr.length > prev.length ? curr : prev 
            })

          }
          let label = ''
          
          if (kq) {
            if (kf.length > kq.length) {
              console.log('kq', kq, ' - kf', kf)
              let index = parseInt(kf.substring(kq.length + 1))
              console.log('Index', index)
              label = this.questions[kq].a.files[index].label.fr
            } else {
              label = this.questions[kq].a.file.label.fr
            }
          }

          return label + '<ul><li>' + files.map(f => `<a href="${ServiceAccess.instance.serviceURL}/file/${this.$route.params.sessionId}/${f.hashname}">${f.filename}</a>`).join('</li><li>') + '</li></ul>'
        }).join('<br>')
      } else if (this.questions[k]) {
        let qtype = this.questions[k].a.type
        if (qtype === 'number' || qtype === 'text') {
          return v
        } else if (qtype === 'boolean' || qtype === 'check') {
          return v ? 'Oui' : 'Non'
        } else if (qtype === 'date') {
          moment.locale('fr')
          let date = moment(v, 'YYYY-MM-DD')
          return date.format('Do MMMM YYYY')
        } else if (qtype === 'array') {
          if (v instanceof Array) {
            return '<ul><li>' + v.map(v => this.questions[k].array(this.values)[v].fr).join('</li><li>') + '</li></ul>'
          } else {
            return this.questions[k].array(this.values)[v].fr
          }
        } else {
          return JSON.stringify(v)
        }
      } else {
        return JSON.stringify(v)
      }
    }
  }



}

</script>


// WEBPACK FOOTER //
// ScreenAdmin.vue?0c8c9e0e